module.exports = __webpack_public_path__ + "img/img4.ff5360ce.png";